var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPizza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,72c-2.1,0-2.1,3.3,0,3.3C74.1,75.3,74.1,72,72,72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,88.6c-3.2,0-5.7,2.6-5.7,5.7c0,3.2,2.6,5.7,5.7,5.7c3.2,0,5.7-2.6,5.7-5.7 C88.4,91.1,85.8,88.6,82.7,88.6 M84,94.3c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3S82,93,82.7,93C83.4,93,84,93.5,84,94.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,43.3c2.1,0,2.1-3.3,0-3.3C69.8,40,69.8,43.3,72,43.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,22.2c-2.1,0-2.1,3.3,0,3.3S68.3,22.2,66.2,22.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9,53.1c-2.1,0-2.1,3.3,0,3.3C66,56.4,66,53.1,63.9,53.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,62.6c-4.9,0-4.9,7.7,0,7.7C66.6,70.3,66.6,62.6,61.5,62.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,30.8c-4.9,0-4.9,7.7,0,7.7S62.8,30.8,57.9,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3,66.7c-2.1,0-2.1,3.3,0,3.3S53.4,66.7,51.3,66.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,37.2c2.1,0,2.1-3.3,0-3.3C40.4,33.9,40.4,37.2,42.6,37.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3,44.4c-5.3-5.1-13.8-4.9-18.9,0.4c-5.1,5.3-4.9,13.8,0.4,18.9s13.8,4.9,18.9-0.4 C56.9,58,56.7,49.5,51.3,44.4 M48.6,60.3c-3.4,3.6-9.1,3.7-12.7,0.3c-3.6-3.4-3.7-9.1-0.3-12.7c3.4-3.6,9.1-3.7,12.7-0.3 C51.9,51,52,56.7,48.6,60.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3,77.7L74,14.1c0.7-0.1,1.3-0.7,1.6-1.4c1.8-4.5,0.3-9.6-3.8-12.3C71.4,0.1,71,0,70.6,0 C34.6,0.8,6.1,30.6,6.9,66.5c0,0.5,0.2,1,0.5,1.3L7.5,68c2.9,3.7,8,4.9,12.3,3c0.5-0.2,0.9-0.7,1.1-1.2L36,73.5 c1.3,0.3,2.4,1,3.3,2.1c0.8,1,1.3,2.3,1.3,3.6v4.6c0,2,0.7,3.9,2.1,5.3c1.4,1.4,3.4,2.2,5.4,2.2c4.1,0,7.6-3.4,7.6-7.5v-3.2 c0-0.5,0.1-1,0.5-1.3c0.4-0.3,0.9-0.4,1.3-0.3l4.4,1.1c0.6,0.1,0.9,0.5,1.3,1c0.4,0.5,0.4,1,0.4,1.6v9.6c0,1.6,0.8,3.2,2,4.4 c1.2,1.2,3,1.8,4.6,1.8c3.4,0,6.4-2.8,6.4-6.2v-7c0-0.5,0.1-0.9,0.3-1c0.3-0.2,0.6-0.3,1-0.2l7.6,1.9c3.5,0.9,7-1.3,7.9-4.7 C93.7,80.1,93.7,78.9,93.3,77.7 M86.1,69c-5.6,1.4-11.4-2-12.8-7.6C72,56.1,74.9,50.7,80,48.8L86.1,69z M16.9,66.8 c0,0.2,0,0.4-0.1,0.6c-2,0.4-4.2-0.2-5.6-1.7C10.9,32.8,37,5.5,69.9,4.4c1.3,1.1,2.1,2.7,2.1,4.4c0,0.4,0,0.7-0.1,1.1 c-0.4,0.1-0.7,0.1-1.1,0.2C42.3,14.9,20.2,38.2,16.9,66.8 M88.6,81.1c-0.5,0.6-1.3,0.8-2,0.6L79,79.8c-1.7-0.4-3.4,0-4.7,1 c-1.4,1.1-2,2.7-2,4.5v7c0,1-0.9,1.8-1.9,1.8c-0.5,0-1.2-0.2-1.6-0.6c-0.3-0.3-0.8-0.8-0.8-1.3v-9.6c0-1.6-0.3-3.1-1.3-4.3 c-0.9-1.2-2.3-2.1-3.7-2.5l-4.3-1.1c-1.8-0.4-3.6,0-5,1.1c-1.5,1.2-2.2,2.9-2.2,4.8v3.2c0,1.7-1.5,3.1-3.2,3.1 c-0.8,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.4-0.9-2.2v-4.6c0-4.7-3.2-8.8-7.8-9.9l-15.5-3.8c3.7-25.2,23.1-45.6,48-50.6l9.1,29.8 c-7.8,2.6-12,11.1-9.3,19c2.5,7.5,10.4,11.7,18,9.6l1.8,5.8C89.3,79.7,89.2,80.5,88.6,81.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/Pizza.e8314c3027ba3dba31154fa0cf998808.svg";
export { ForwardRef as ReactComponent };